export default `Region,Population
Andalusia,"8414240"
Catalonia,"7675217"
Community of Madrid,"6663394"
Valencian Community,"5003769"
Galicia,"2699499"
Castile and León,"2399548"
Basque Autonomous Community,"2207776"
Castilla-La Mancha,"2032863"
Canary Islands,"2153389"
Region of Murcia,"1493898"
Aragon,"1319291"
Extremadura,"1067710"
Balearic Islands,"1149460"
Principality of Asturias,"1022800"
Chartered Community of Navarre,"654214"
Cantabria,"581078"
La Rioja,"316798"`